
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./jitsu.cjs.production.min.js')
} else {
  module.exports = require('./jitsu.cjs.development.js')
}
